import withTicketListData from './container';
import RoyalTicketList from './view';

export default withTicketListData(RoyalTicketList);
